function checkHttps(url: string) {
  if (!url.startsWith('https://')) {
    return `https://${url}`;
  }
  return url;
}

export function addWebProtocolIfNeeded(url: string) {
  // doesn't change url if is a /l/awards
  if (url.startsWith('/')) {
    return url;
  }
  // doesn't change url if already include web protocol (https://www)
  let validUrl = url;
  if (url.startsWith('https://www')) {
    return url;
  }
  // change url if url includes "https://" but does not includes "www."
  if (url.startsWith('https://') && url.split('//')[1] !== 'www') {
    return checkHttps(url.split('https://')[1]);
  }
  // add "https://" and "www."
  validUrl = checkHttps(url);
  return validUrl;
}
